export const enumKeys = <T extends Record<string, unknown>>(enumObj: T): (keyof T)[] => {
  const isInteger = /^\d+$/;
  return Object.keys(enumObj)
    .filter(k => !isInteger.test(k))
    .map(k => k as keyof T);
};
export const enumValues = <T extends Record<string, unknown>>(enumObj: T): T[keyof T][] => {
  return enumKeys(enumObj).map(k => enumObj[k]);
};
